import React, { useContext, VFC } from 'react';

import ArticleBlock from '/components/ArticleBlock';
import { ContentColumn, TableColumn } from '/components/BlockColumns';
import { useColsCollapsed, LAYOUT } from '/components/common';
import { BlockProps, ColumnContainerJson } from '/types';
import { PresentModeContext } from '/utils/contexts';
import { filterKeynoteColumns } from '/utils/functions';

const BlockTable: VFC<BlockProps> = ({
  animationEnabled,
  animationStep,
  setAnimationComplete,
  blockContent,
  blockBackgroundType,
  presentOption,
  ...props
}) => {
  const presentMode = useContext(PresentModeContext);
  const colsCollapsed = useColsCollapsed();
  const columnData = filterKeynoteColumns(
    blockContent.columns?.list || [],
    presentMode,
    presentOption,
  );
  const layout = blockContent.columns?.layout;

  // Table first when collapsed or if wider column is to the left
  if (colsCollapsed || layout === LAYOUT.LEFT) {
    columnData.sort((a) => (a.name === 'table' ? 0 : 1));
  }

  setAnimationComplete(animationStep >= 1);

  return (
    <ArticleBlock
      {...props}
      blockContent={blockContent}
      blockBackgroundType={blockBackgroundType}
      hideFooter={animationEnabled && !animationStep}
      offset={1}
      titleCentered
      rowCenterAlign
      columns={columnData.map((column: ColumnContainerJson) => (
        <>
          {!column.hidden && column.name === 'table' && (
            <TableColumn
              background={blockBackgroundType}
              elements={column.elements}
              hide={animationEnabled && !animationStep}
            />
          )}
          {!column.hidden && column.name === 'content' && (
            <ContentColumn
              elements={column.elements}
              presentOption={presentOption}
              hide={animationEnabled && !animationStep}
            />
          )}
        </>
      ))}
    />
  );
};

BlockTable.displayName = 'BlockTable';
export default BlockTable;
